export default class RuntimeError extends Error {
  constructor(message, line, column) {
    const msg = `Runtime error: ${message} at line ${line}:${column}`;
    super(msg);
  }
}
